module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.accesses-for')) + " | Mobile: " + _vm._s(_vm.mobile.contact_name))]), _vm._v(" "), _c('single-access', {
    attrs: {
      "access-holders": _vm.accessHolders,
      "unprocessed-accesses": _vm.unprocessedAccesses,
      "columns": ['controllerName', 'name'],
      "mobile-id": _vm.mobileId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-331753fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/access/SingleMobileAccess.vue
// module id = 986
// module chunks = 2